import { FC, memo } from 'react';
import type { NodeToRenderProps } from '../types/custom-nodes.type';
import { applyStartingHocs } from '../../../scenario-editor/utils';
import { FinishComponent } from './FinishComponent';

export const NodeToRender: FC<NodeToRenderProps>  = FinishComponent as FC<NodeToRenderProps>;

const Node = applyStartingHocs(NodeToRender);

const NodeWithHandles: React.FC<NodeToRenderProps> = (props) => {
  return (
    <Node {...props}>{props.children}</Node>
  );
};

export const FinishNode = memo(NodeWithHandles);
